import queryString, { type ParseOptions } from 'query-string';

// Keeps the `any` return of the retired @types/query-string@5 that existing callers were written against.
export const parse = (query: string, options?: ParseOptions): any => queryString.parse(query, options);

export const { stringify } = queryString;
